// extracted by mini-css-extract-plugin
export default {"Header-Margin":"header_Header-Margin__N-uM-","Nom-Prenom-Sia":"header_Nom-Prenom-Sia__FblZh"};